import { ShieldCheckIcon, ClockIcon, MapPinIcon } from "@heroicons/react/24/outline";

interface DirectoryHeaderProps {
  hasSearched?: boolean;
}

const DirectoryHeader = ({ hasSearched = false }: DirectoryHeaderProps) => {
  return (
    <>
      <div className="bg-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <img src="/Patient360.svg" alt="Patient360" className="w-24" />
        </div>
      </div>
      <div className="bg-gradient-to-r from-brand-600 to-brand-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {!hasSearched && (
          <div className="text-center py-3 sm:py-4">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-6 drop-shadow-md">
              Find Your Perfect Doctor
            </h1>
            <p className="text-sm sm:text-lg lg:text-xl mb-2 sm:mb-4 mx-auto opacity-90 max-w-lg lg:max-w-none">
              Discover qualified health care providers in your area with our comprehensive search platform.
            </p>
            <p className="text-sm sm:text-lg lg:text-xl mb-6 sm:mb-12 mx-auto opacity-90 max-w-lg lg:max-w-none">
              Search by location, specialty, or name to find the right health care provider for you
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 lg:gap-8 mb-6 sm:mb-16 max-w-sm sm:max-w-none mx-auto">
              <div className="flex sm:flex-col items-center sm:space-y-2 gap-3 sm:gap-0 bg-white/10 backdrop-blur-sm px-4 sm:px-8 py-3 sm:py-6 rounded-lg text-left sm:text-center">
                <ShieldCheckIcon className="w-8 h-8 sm:w-12 sm:h-12 flex-shrink-0" />
                <div className="sm:contents">
                  <span className="text-sm sm:text-xl font-medium block">Trusted Healthcare</span>
                  <p className="text-xs sm:text-sm opacity-80 sm:opacity-100">All providers are verified and licensed healthcare professionals</p>
                </div>
              </div>
              <div className="flex sm:flex-col items-center sm:space-y-2 gap-3 sm:gap-0 bg-white/10 backdrop-blur-sm px-4 sm:px-8 py-3 sm:py-6 rounded-lg text-left sm:text-center">
                <ClockIcon className="w-8 h-8 sm:w-12 sm:h-12 flex-shrink-0" />
                <div className="sm:contents">
                  <span className="text-sm sm:text-xl font-medium block">24/7 Support</span>
                  <p className="text-xs sm:text-sm opacity-80 sm:opacity-100">Get assistance anytime for your healthcare needs.</p>
                </div>
              </div>
              <div className="flex sm:flex-col items-center sm:space-y-2 gap-3 sm:gap-0 bg-white/10 backdrop-blur-sm px-4 sm:px-8 py-3 sm:py-6 rounded-lg text-left sm:text-center">
                <MapPinIcon className="w-8 h-8 sm:w-12 sm:h-12 flex-shrink-0" />
                <div className="sm:contents">
                  <span className="text-sm sm:text-xl font-medium block">Location-Based Search</span>
                  <p className="text-xs sm:text-sm opacity-80 sm:opacity-100">Find provider within your preferred radius zip code area</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default DirectoryHeader;
